var _rect, _g, _g2, _line, _line2, _line3, _rect2, _path, _rect3, _path2, _line4, _line5, _line6, _line7, _rect4, _path3, _line8, _line9, _rect5, _path4, _rect6, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecFab2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 150,
    viewBox: "0 0 360 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 150,
    fill: "#E2E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_5363_312214)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 47,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 76H95V82H93V76H87V74H93V68H95V74H101V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 63.5,
    width: 23,
    height: 23,
    stroke: "#FF1844"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_5363_312214)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 47,
    width: 144,
    height: 56,
    rx: 28,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 76H177V82H175V76H169V74H175V68H177V74H183V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.319 80.5V70.5059H202.953V79.0986H207.185V80.5H201.319ZM213.467 80.5L213.146 79.4473H213.091C212.726 79.9076 212.359 80.222 211.99 80.3906C211.621 80.5547 211.147 80.6367 210.568 80.6367C209.826 80.6367 209.244 80.4362 208.825 80.0352C208.41 79.6341 208.203 79.0667 208.203 78.333C208.203 77.5537 208.493 76.9658 209.071 76.5693C209.65 76.1729 210.532 75.9564 211.717 75.9199L213.022 75.8789V75.4756C213.022 74.9925 212.909 74.6325 212.681 74.3955C212.457 74.154 212.109 74.0332 211.635 74.0332C211.247 74.0332 210.876 74.0902 210.521 74.2041C210.165 74.318 209.823 74.4525 209.495 74.6074L208.976 73.459C209.386 73.2448 209.835 73.083 210.322 72.9736C210.81 72.8597 211.27 72.8027 211.703 72.8027C212.665 72.8027 213.389 73.0124 213.877 73.4316C214.369 73.8509 214.615 74.5094 214.615 75.4072V80.5H213.467ZM211.074 79.4062C211.658 79.4062 212.125 79.2445 212.476 78.9209C212.831 78.5928 213.009 78.1348 213.009 77.5469V76.8906L212.038 76.9316C211.282 76.959 210.73 77.0866 210.384 77.3145C210.042 77.5378 209.871 77.8818 209.871 78.3467C209.871 78.6839 209.971 78.946 210.172 79.1328C210.372 79.3151 210.673 79.4062 211.074 79.4062ZM220.692 72.8027C221.016 72.8027 221.283 72.8255 221.492 72.8711L221.335 74.3682C221.107 74.3135 220.87 74.2861 220.624 74.2861C219.981 74.2861 219.46 74.4958 219.059 74.915C218.662 75.3343 218.464 75.8789 218.464 76.5488V80.5H216.857V72.9395H218.115L218.327 74.2725H218.409C218.66 73.8213 218.986 73.4635 219.387 73.1992C219.792 72.9349 220.228 72.8027 220.692 72.8027ZM229.285 72.9395V73.8213L227.993 74.0605C228.112 74.2201 228.21 74.416 228.287 74.6484C228.365 74.8809 228.403 75.127 228.403 75.3867C228.403 76.166 228.134 76.779 227.597 77.2256C227.059 77.6722 226.318 77.8955 225.375 77.8955C225.133 77.8955 224.915 77.8773 224.719 77.8408C224.372 78.055 224.199 78.3057 224.199 78.5928C224.199 78.766 224.279 78.8958 224.438 78.9824C224.603 79.069 224.901 79.1123 225.334 79.1123H226.653C227.487 79.1123 228.121 79.29 228.554 79.6455C228.987 80.001 229.203 80.5137 229.203 81.1836C229.203 82.0404 228.85 82.7012 228.144 83.166C227.437 83.6309 226.416 83.8633 225.081 83.8633C224.051 83.8633 223.265 83.681 222.723 83.3164C222.18 82.9518 221.909 82.4323 221.909 81.7578C221.909 81.293 222.055 80.901 222.347 80.582C222.643 80.2676 223.055 80.0488 223.584 79.9258C223.37 79.8346 223.192 79.6888 223.051 79.4883C222.914 79.2832 222.846 79.069 222.846 78.8457C222.846 78.5632 222.925 78.3239 223.085 78.1279C223.244 77.932 223.481 77.7383 223.796 77.5469C223.404 77.3783 223.085 77.1048 222.839 76.7266C222.597 76.3438 222.477 75.8971 222.477 75.3867C222.477 74.5664 222.734 73.9307 223.249 73.4795C223.769 73.0283 224.507 72.8027 225.464 72.8027C225.678 72.8027 225.901 72.8187 226.134 72.8506C226.371 72.8779 226.549 72.9076 226.667 72.9395H229.285ZM223.345 81.6758C223.345 82.0221 223.5 82.2887 223.81 82.4756C224.124 82.6624 224.564 82.7559 225.129 82.7559C226.004 82.7559 226.656 82.6305 227.084 82.3799C227.512 82.1292 227.727 81.7965 227.727 81.3818C227.727 81.0537 227.608 80.819 227.371 80.6777C227.139 80.541 226.703 80.4727 226.065 80.4727H224.849C224.388 80.4727 224.021 80.5798 223.748 80.7939C223.479 81.0127 223.345 81.3066 223.345 81.6758ZM224.035 75.3867C224.035 75.8607 224.156 76.2253 224.397 76.4805C224.644 76.7357 224.994 76.8633 225.45 76.8633C226.38 76.8633 226.845 76.3665 226.845 75.373C226.845 74.8809 226.729 74.5026 226.496 74.2383C226.268 73.9694 225.92 73.835 225.45 73.835C224.985 73.835 224.632 73.9671 224.391 74.2314C224.154 74.4958 224.035 74.8809 224.035 75.3867ZM233.995 80.6367C232.819 80.6367 231.899 80.2949 231.233 79.6113C230.573 78.9232 230.242 77.9775 230.242 76.7744C230.242 75.5394 230.55 74.5687 231.165 73.8623C231.78 73.1559 232.626 72.8027 233.701 72.8027C234.699 72.8027 235.488 73.1058 236.066 73.7119C236.645 74.318 236.935 75.152 236.935 76.2139V77.082H231.896C231.919 77.8158 232.118 78.3809 232.491 78.7773C232.865 79.1693 233.391 79.3652 234.07 79.3652C234.517 79.3652 234.932 79.3242 235.314 79.2422C235.702 79.1556 236.117 79.0143 236.559 78.8184V80.124C236.167 80.3109 235.77 80.443 235.369 80.5205C234.968 80.598 234.51 80.6367 233.995 80.6367ZM233.701 74.0195C233.191 74.0195 232.781 74.1813 232.471 74.5049C232.165 74.8285 231.983 75.3001 231.924 75.9199H235.355C235.346 75.2956 235.196 74.8239 234.904 74.5049C234.613 74.1813 234.212 74.0195 233.701 74.0195ZM244.188 80.5H242.567V70.5059H248.207V71.8867H244.188V75.0107H247.954V76.3984H244.188V80.5ZM256.219 80.5L255.221 77.7246H251.399L250.422 80.5H248.699L252.438 70.4648H254.216L257.955 80.5H256.219ZM254.79 76.3164L253.854 73.5957C253.785 73.4134 253.689 73.1263 253.566 72.7344C253.448 72.3424 253.366 72.0553 253.32 71.873C253.197 72.4336 253.017 73.0465 252.78 73.7119L251.878 76.3164H254.79ZM259.274 70.5059H262.241C263.618 70.5059 264.611 70.7064 265.222 71.1074C265.837 71.5085 266.145 72.1419 266.145 73.0078C266.145 73.5911 265.994 74.0765 265.693 74.4639C265.393 74.8512 264.96 75.0951 264.395 75.1953V75.2637C265.096 75.3958 265.611 75.6579 265.939 76.0498C266.272 76.4372 266.438 76.9635 266.438 77.6289C266.438 78.5267 266.124 79.2308 265.495 79.7412C264.871 80.2471 264 80.5 262.884 80.5H259.274V70.5059ZM260.908 74.6348H262.48C263.164 74.6348 263.663 74.5277 263.978 74.3135C264.292 74.0947 264.449 73.7256 264.449 73.2061C264.449 72.7367 264.278 72.3971 263.937 72.1875C263.599 71.9779 263.062 71.873 262.323 71.873H260.908V74.6348ZM260.908 75.9609V79.126H262.645C263.328 79.126 263.843 78.9961 264.189 78.7363C264.54 78.472 264.716 78.0573 264.716 77.4922C264.716 76.9727 264.538 76.5876 264.183 76.3369C263.827 76.0863 263.287 75.9609 262.562 75.9609H260.908Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.5,
    y1: 47,
    x2: 66.5,
    y2: 23,
    stroke: "#2A7AFF",
    strokeDasharray: "1 1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    y1: 47,
    x2: 121.5,
    y2: 23,
    stroke: "#2A7AFF",
    strokeDasharray: "1 1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34.5,
    x2: 122,
    y2: 34.5,
    stroke: "#2A7AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(84 26)",
    fill: "#2A7AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4082 35.0098L87.9141 30.0469H93.0137V31.2158H88.9873L88.6865 33.9297C89.1742 33.6426 89.7279 33.499 90.3477 33.499C91.2546 33.499 91.9746 33.7998 92.5078 34.4014C93.041 34.9984 93.3076 35.8073 93.3076 36.8281C93.3076 37.8535 93.0296 38.6624 92.4736 39.2549C91.9222 39.8428 91.1497 40.1367 90.1562 40.1367C89.2767 40.1367 88.5589 39.8929 88.0029 39.4053C87.4469 38.9176 87.1302 38.2432 87.0527 37.3818H88.249C88.3265 37.9515 88.5293 38.3822 88.8574 38.6738C89.1855 38.9609 89.6185 39.1045 90.1562 39.1045C90.7441 39.1045 91.2044 38.904 91.5371 38.5029C91.8743 38.1019 92.043 37.5482 92.043 36.8418C92.043 36.1764 91.8607 35.6432 91.4961 35.2422C91.1361 34.8366 90.6553 34.6338 90.0537 34.6338C89.5023 34.6338 89.0693 34.7546 88.7549 34.9961L88.4199 35.2695L87.4082 35.0098ZM99.6514 30.04V31.1133H99.4189C98.4346 31.1315 97.6507 31.4232 97.0674 31.9883C96.484 32.5534 96.1468 33.3486 96.0557 34.374C96.5798 33.7725 97.2952 33.4717 98.2021 33.4717C99.068 33.4717 99.7585 33.777 100.273 34.3877C100.793 34.9984 101.053 35.7868 101.053 36.7529C101.053 37.7783 100.772 38.5986 100.212 39.2139C99.6559 39.8291 98.9085 40.1367 97.9697 40.1367C97.0173 40.1367 96.2448 39.7721 95.6523 39.043C95.0599 38.3092 94.7637 37.3659 94.7637 36.2129V35.7275C94.7637 33.8955 95.1533 32.4964 95.9326 31.5303C96.7165 30.5596 97.8809 30.0628 99.4258 30.04H99.6514ZM97.9902 34.5244C97.5573 34.5244 97.1585 34.6543 96.7939 34.9141C96.4294 35.1738 96.1764 35.4997 96.0352 35.8916V36.3564C96.0352 37.1768 96.2197 37.8376 96.5889 38.3389C96.958 38.8402 97.4183 39.0908 97.9697 39.0908C98.5394 39.0908 98.986 38.8812 99.3096 38.4619C99.6377 38.0426 99.8018 37.4935 99.8018 36.8145C99.8018 36.1309 99.6354 35.5794 99.3027 35.1602C98.9746 34.7363 98.5371 34.5244 97.9902 34.5244Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(84 91)",
    fill: "#FF1844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3486 105H86.8271V104.091L90.2725 100.263C90.7829 99.6839 91.1338 99.2145 91.3252 98.8545C91.5212 98.4899 91.6191 98.1139 91.6191 97.7266C91.6191 97.207 91.4619 96.7809 91.1475 96.4482C90.833 96.1156 90.4137 95.9492 89.8896 95.9492C89.2607 95.9492 88.7708 96.1292 88.4199 96.4893C88.0736 96.8447 87.9004 97.3415 87.9004 97.9795H86.6357C86.6357 97.0635 86.9297 96.3229 87.5176 95.7578C88.11 95.1927 88.9007 94.9102 89.8896 94.9102C90.8148 94.9102 91.5462 95.154 92.084 95.6416C92.6217 96.1247 92.8906 96.7695 92.8906 97.5762C92.8906 98.556 92.2663 99.7227 91.0176 101.076L88.3516 103.968H93.3486V105ZM100.027 101.657H101.408V102.689H100.027V105H98.7559V102.689H94.2236V101.944L98.6807 95.0469H100.027V101.657ZM95.6592 101.657H98.7559V96.7764L98.6055 97.0498L95.6592 101.657Z",
    fill: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 148.5,
    y1: 2.18557e-8,
    x2: 148.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 2.18557e-8,
    x2: 268.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 164.5,
    y1: 2.18557e-8,
    x2: 164.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 291.5,
    y1: 2.18557e-8,
    x2: 291.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(146 25)",
    fill: "#01BFA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 39H151.712V30.5713L149.162 31.5078V30.3594L152.785 28.999H152.983V39ZM161.651 29.04V30.1133H161.419C160.435 30.1315 159.651 30.4232 159.067 30.9883C158.484 31.5534 158.147 32.3486 158.056 33.374C158.58 32.7725 159.295 32.4717 160.202 32.4717C161.068 32.4717 161.758 32.777 162.273 33.3877C162.793 33.9984 163.053 34.7868 163.053 35.7529C163.053 36.7783 162.772 37.5986 162.212 38.2139C161.656 38.8291 160.909 39.1367 159.97 39.1367C159.017 39.1367 158.245 38.7721 157.652 38.043C157.06 37.3092 156.764 36.3659 156.764 35.2129V34.7275C156.764 32.8955 157.153 31.4964 157.933 30.5303C158.716 29.5596 159.881 29.0628 161.426 29.04H161.651ZM159.99 33.5244C159.557 33.5244 159.159 33.6543 158.794 33.9141C158.429 34.1738 158.176 34.4997 158.035 34.8916V35.3564C158.035 36.1768 158.22 36.8376 158.589 37.3389C158.958 37.8402 159.418 38.0908 159.97 38.0908C160.539 38.0908 160.986 37.8812 161.31 37.4619C161.638 37.0426 161.802 36.4935 161.802 35.8145C161.802 35.1309 161.635 34.5794 161.303 34.1602C160.975 33.7363 160.537 33.5244 159.99 33.5244Z",
    fill: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 188.5,
    y1: 2.18557e-8,
    x2: 188.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 199.5,
    y1: 2.18557e-8,
    x2: 199.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(184 25)",
    fill: "#01BFA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.983 39H189.712V30.5713L187.162 31.5078V30.3594L190.785 28.999H190.983V39ZM201.21 39H194.688V38.0908L198.134 34.2627C198.644 33.6839 198.995 33.2145 199.187 32.8545C199.382 32.4899 199.48 32.1139 199.48 31.7266C199.48 31.207 199.323 30.7809 199.009 30.4482C198.694 30.1156 198.275 29.9492 197.751 29.9492C197.122 29.9492 196.632 30.1292 196.281 30.4893C195.935 30.8447 195.762 31.3415 195.762 31.9795H194.497C194.497 31.0635 194.791 30.3229 195.379 29.7578C195.971 29.1927 196.762 28.9102 197.751 28.9102C198.676 28.9102 199.408 29.154 199.945 29.6416C200.483 30.1247 200.752 30.7695 200.752 31.5762C200.752 32.556 200.128 33.7227 198.879 35.0762L196.213 37.9678H201.21V39Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(270 25)",
    fill: "#01BFA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M279.349 39H272.827V38.0908L276.272 34.2627C276.783 33.6839 277.134 33.2145 277.325 32.8545C277.521 32.4899 277.619 32.1139 277.619 31.7266C277.619 31.207 277.462 30.7809 277.147 30.4482C276.833 30.1156 276.414 29.9492 275.89 29.9492C275.261 29.9492 274.771 30.1292 274.42 30.4893C274.074 30.8447 273.9 31.3415 273.9 31.9795H272.636C272.636 31.0635 272.93 30.3229 273.518 29.7578C274.11 29.1927 274.901 28.9102 275.89 28.9102C276.815 28.9102 277.546 29.154 278.084 29.6416C278.622 30.1247 278.891 30.7695 278.891 31.5762C278.891 32.556 278.266 33.7227 277.018 35.0762L274.352 37.9678H279.349V39ZM286.027 35.6572H287.408V36.6895H286.027V39H284.756V36.6895H280.224V35.9443L284.681 29.0469H286.027V35.6572ZM281.659 35.6572H284.756V30.7764L284.605 31.0498L281.659 35.6572Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5363_312214",
    x: 40,
    y: 26,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.305882 0 0 0 0 0.329412 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5363_312214",
    result: "effect2_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5363_312214",
    result: "effect3_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5363_312214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5363_312214",
    x: 122,
    y: 26,
    width: 196,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.305882 0 0 0 0 0.329412 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5363_312214",
    result: "effect2_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5363_312214",
    result: "effect3_dropShadow_5363_312214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5363_312214",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecFab2);
export default __webpack_public_path__ + "static/media/spec-fab-2.25f00a600e2f0f862b331dfadbb43537.svg";
export { ForwardRef as ReactComponent };